module.exports = __webpack_public_path__ + "assets/img/202112-1.14bdc477.png";